import Link from 'next/link';
import { FC, ReactNode } from 'react';

import StoryblokLink from '../StoryblokLink';

export interface ButtonElementProps {
  children?: ReactNode;
  url?: string;
  style?: string;
  color?: string;
  className?: string;
  link?: object;
  form?: boolean;
  target?: string;
}

const BUTTON_STYLE = {
  primary: 'btn btn-primary',
  secondary: 'btn btn-secondary',
  transparent: 'text-lift-blue hover:text-lift-blue',
  text: 'flex items-center justify-start gap-x-6 p-0 text-lift-red hover:text-lift-red duration-300',
};

const BUTTON_COLOR = {
  base: '',
  accent: 'text-lift-red text-projectAccent',
};

const baseClasses =
  'focus:outline-none focus:ring-2 focus:ring-lift-blue focus:ring-offset-2 cursor-pointer';

const ButtonElement: FC<ButtonElementProps> = ({
  children,
  color = 'base',
  style = 'text',
  link,
  url,
  form = false,
  className,
  target,
}) => {
  const buttonStyle = BUTTON_STYLE[style];
  const buttonColor = BUTTON_COLOR[color];

  if (form) {
    return (
      <span
        className={`${baseClasses} ${buttonStyle} ${buttonColor} ${className}`}
      >
        {children}
      </span>
    );
  }

  if (url) {
    return (
      <Link href={url ?? ''} target={target} passHref>
        <span
          className={`${baseClasses} ${buttonStyle} ${buttonColor} ${className}`}
        >
          {children}
        </span>
      </Link>
    );
  }
  return (
    <StoryblokLink link={link} passHref={true}>
      <span
        className={`${baseClasses} ${buttonStyle} ${buttonColor} ${className}`}
      >
        {children}
      </span>
    </StoryblokLink>
  );
};

export default ButtonElement;
